import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-8">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: July 2026</p>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">1. Information We Collect</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Account Information:</strong> Name, email address, and password (encrypted) when you register.</li>
              <li><strong>Payment Information:</strong> Payment details are processed by Razorpay. We do not store card numbers.</li>
              <li><strong>Usage Data:</strong> Test attempts, scores, and performance analytics to provide insights.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>To provide and maintain our services.</li>
              <li>To process payments and grant access to test series.</li>
              <li>To send transactional emails (welcome, OTP verification, payment confirmation).</li>
              <li>To analyze usage patterns and improve our platform.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">3. Data Security</h2>
            <p>
              We use industry-standard security measures including encrypted passwords (bcrypt), JWT-based authentication, and HTTPS to protect your data. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">4. Third-Party Services</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Razorpay:</strong> For payment processing. See Razorpay's privacy policy.</li>
              <li><strong>Resend:</strong> For transactional emails.</li>
              <li><strong>Google reCAPTCHA:</strong> For spam prevention. See Google's privacy policy.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">5. Cookies</h2>
            <p>
              We use localStorage to store authentication tokens for session management. We do not use third-party tracking cookies.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">6. Your Rights</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>You can request deletion of your account and associated data.</li>
              <li>You can update your profile information at any time.</li>
              <li>You can contact us to know what data we hold about you.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">7. Data Retention</h2>
            <p>
              We retain your account data as long as your account is active. Test attempt data is retained for analytics purposes. You can request deletion by contacting support.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">8. Contact</h2>
            <p>
              For privacy-related queries, contact us at{' '}
              <a href="mailto:support@pinakaclasses.com" className="text-primary hover:underline">
                support@pinakaclasses.com
              </a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
